module.exports = __webpack_public_path__ + "static/media/8900_Pool2.6c232ef4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Pool2.jpg
// module id = 581
// module chunks = 0